export default function IconAddDomainFail() {
    return (
        <svg
            width="220"
            height="120"
            viewBox="0 0 220 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_7735_372142)">
                <path
                    d="M163.699 116.132V103.602C163.699 103.602 168.567 112.485 163.699 116.132Z"
                    fill="#F1F1F1"
                />
                <path
                    d="M164 116.129L154.799 107.655C154.799 107.655 164.614 110.066 164 116.129Z"
                    fill="#F1F1F1"
                />
                <path
                    d="M66.5113 3.5H44.5037L33.5 22.6194L44.5037 41.739H66.5113L77.5149 22.6194L66.5113 3.5Z"
                    fill="#E6E6E6"
                />
                <path
                    d="M45.7393 39.5933H65.2766L75.0452 22.6199L65.2766 5.64648H45.7393L35.9707 22.6199L45.7393 39.5933Z"
                    fill="white"
                />
                <path
                    d="M45.5029 18.4607C46.0007 18.4607 46.4042 18.0559 46.4042 17.5565C46.4042 17.0572 46.0007 16.6523 45.5029 16.6523C45.0051 16.6523 44.6016 17.0572 44.6016 17.5565C44.6016 18.0559 45.0051 18.4607 45.5029 18.4607Z"
                    fill="#E2E2E2"
                />
                <path
                    d="M45.5029 23.5232C46.0007 23.5232 46.4042 23.1184 46.4042 22.619C46.4042 22.1197 46.0007 21.7148 45.5029 21.7148C45.0051 21.7148 44.6016 22.1197 44.6016 22.619C44.6016 23.1184 45.0051 23.5232 45.5029 23.5232Z"
                    fill="#E2E2E2"
                />
                <path
                    d="M45.5029 28.5867C46.0007 28.5867 46.4042 28.1819 46.4042 27.6825C46.4042 27.1831 46.0007 26.7783 45.5029 26.7783C45.0051 26.7783 44.6016 27.1831 44.6016 27.6825C44.6016 28.1819 45.0051 28.5867 45.5029 28.5867Z"
                    fill="#E2E2E2"
                />
                <path
                    d="M66.414 16.833H49.2891V18.2797H66.414V16.833Z"
                    fill="#E2E2E2"
                />
                <path
                    d="M66.414 21.8965H49.2891V23.3432H66.414V21.8965Z"
                    fill="#E2E2E2"
                />
                <path
                    d="M66.414 26.96H49.2891V28.4066H66.414V26.96Z"
                    fill="#E2E2E2"
                />
                <path
                    d="M175.496 3.5H153.488L142.484 22.6194L153.488 41.739H175.496L186.499 22.6194L175.496 3.5Z"
                    fill="#E6E6E6"
                />
                <path
                    d="M154.724 39.5933H174.261L184.03 22.6199L174.261 5.64648H154.724L144.955 22.6199L154.724 39.5933Z"
                    fill="white"
                />
                <path
                    d="M154.487 18.4607C154.985 18.4607 155.389 18.0559 155.389 17.5565C155.389 17.0572 154.985 16.6523 154.487 16.6523C153.989 16.6523 153.586 17.0572 153.586 17.5565C153.586 18.0559 153.989 18.4607 154.487 18.4607Z"
                    fill="#E2E2E2"
                />
                <path
                    d="M154.487 23.5232C154.985 23.5232 155.389 23.1184 155.389 22.619C155.389 22.1197 154.985 21.7148 154.487 21.7148C153.989 21.7148 153.586 22.1197 153.586 22.619C153.586 23.1184 153.989 23.5232 154.487 23.5232Z"
                    fill="#E2E2E2"
                />
                <path
                    d="M154.487 28.5867C154.985 28.5867 155.389 28.1819 155.389 27.6825C155.389 27.1831 154.985 26.7783 154.487 26.7783C153.989 26.7783 153.586 27.1831 153.586 27.6825C153.586 28.1819 153.989 28.5867 154.487 28.5867Z"
                    fill="#E2E2E2"
                />
                <path
                    d="M175.398 16.833H158.273V18.2797H175.398V16.833Z"
                    fill="#E2E2E2"
                />
                <path
                    d="M175.398 21.8965H158.273V23.3432H175.398V21.8965Z"
                    fill="#E2E2E2"
                />
                <path
                    d="M175.398 26.96H158.273V28.4066H175.398V26.96Z"
                    fill="#E2E2E2"
                />
                <path
                    d="M120.898 3.68555H99.1038L88.207 22.6193L99.1038 41.5532H120.898L131.795 22.6193L120.898 3.68555Z"
                    fill="#A9B2FF"
                />
                <path
                    d="M100.326 39.4277H119.674L129.347 22.6191L119.674 5.81055H100.326L90.6523 22.6191L100.326 39.4277Z"
                    fill="white"
                />
                <path
                    d="M100.092 18.5007C100.585 18.5007 100.984 18.0999 100.984 17.6054C100.984 17.1108 100.585 16.71 100.092 16.71C99.5988 16.71 99.1992 17.1108 99.1992 17.6054C99.1992 18.0999 99.5988 18.5007 100.092 18.5007Z"
                    fill="#7B67FB"
                />
                <path
                    d="M100.092 23.5144C100.585 23.5144 100.984 23.1135 100.984 22.619C100.984 22.1245 100.585 21.7236 100.092 21.7236C99.5988 21.7236 99.1992 22.1245 99.1992 22.619C99.1992 23.1135 99.5988 23.5144 100.092 23.5144Z"
                    fill="#7B67FB"
                />
                <path
                    d="M100.092 28.5291C100.585 28.5291 100.984 28.1282 100.984 27.6337C100.984 27.1392 100.585 26.7383 100.092 26.7383C99.5988 26.7383 99.1992 27.1392 99.1992 27.6337C99.1992 28.1282 99.5988 28.5291 100.092 28.5291Z"
                    fill="#7B67FB"
                />
                <path
                    d="M120.8 16.8887H103.842V18.3213H120.8V16.8887Z"
                    fill="#7B67FB"
                />
                <path
                    d="M120.8 21.9033H103.842V23.3359H120.8V21.9033Z"
                    fill="#7B67FB"
                />
                <path
                    d="M120.8 26.917H103.842V28.3496H120.8V26.917Z"
                    fill="#7B67FB"
                />
                <path
                    d="M128.581 114.31L126.464 114.31L125.457 106.119L128.581 106.119L128.581 114.31Z"
                    fill="#9F616A"
                />
                <path
                    d="M129.12 116.368L122.295 116.368V116.281C122.295 115.574 122.575 114.897 123.073 114.397C123.571 113.897 124.247 113.616 124.952 113.616H124.952L129.121 113.616L129.12 116.368Z"
                    fill="#2F2E41"
                />
                <path
                    d="M148.264 114.31L146.148 114.31L145.141 106.119L148.265 106.119L148.264 114.31Z"
                    fill="#9F616A"
                />
                <path
                    d="M148.804 116.368L141.979 116.368V116.281C141.979 115.574 142.258 114.897 142.757 114.397C143.255 113.897 143.931 113.616 144.635 113.616H144.635L148.804 113.616L148.804 116.368Z"
                    fill="#2F2E41"
                />
                <path
                    d="M127.736 72.7434C127.736 72.7434 125.96 77.5814 126.213 79.6185C126.467 81.6556 124.437 95.9151 124.691 97.1883C124.944 98.4614 124.437 104.827 124.691 105.846C124.944 106.864 123.978 108.081 124.486 109.1C124.993 110.118 125.706 112.212 125.706 112.212L129.006 111.957L129.513 109.156C129.513 109.156 131.036 108.901 130.782 107.374C130.529 105.846 132.052 95.6605 132.052 95.6605L136.367 81.4009L142.459 94.3873C142.459 94.3873 142.712 103.554 143.474 104.573C144.235 105.591 142.712 108.392 143.474 109.411C144.235 110.429 144.997 112.212 144.997 112.212H148.804V110.175C148.804 110.175 151.089 108.901 148.804 105.082L147.261 82.1441L145.738 71.7041L127.736 72.7434Z"
                    fill="#2F2E41"
                />
                <path
                    d="M137.198 40.7258C139.816 40.7258 141.939 38.5964 141.939 35.9698C141.939 33.3432 139.816 31.2139 137.198 31.2139C134.58 31.2139 132.457 33.3432 132.457 35.9698C132.457 38.5964 134.58 40.7258 137.198 40.7258Z"
                    fill="#A0616A"
                />
                <path
                    d="M133.165 35.6412C133.499 36.4986 133.834 37.356 134.168 38.2134C134.58 39.2675 135.051 40.3952 136.015 40.9835C137.205 41.7098 138.794 41.3557 139.946 40.5689C140.981 39.8613 141.776 38.8527 142.224 37.6786C142.671 36.5045 142.75 35.2212 142.449 34.001C142.148 32.7807 141.482 31.6821 140.541 30.8526C139.6 30.0231 138.428 29.5024 137.183 29.3605L137.135 30.2215L136.082 29.3359C136.004 29.47 135.897 29.5846 135.768 29.6712C135.64 29.7578 135.494 29.814 135.341 29.8357C135.187 29.8575 135.031 29.8441 134.884 29.7966C134.737 29.7492 134.602 29.6689 134.49 29.5617C134.767 30.137 134.448 30.8386 133.987 31.2792C133.42 31.8206 131.8 32.4712 131.867 33.4389C131.912 34.0847 132.904 34.9719 133.165 35.6412Z"
                    fill="#2F2E41"
                />
                <path
                    d="M150.249 79.778C150.412 79.5335 150.52 79.2559 150.565 78.965C150.61 78.6741 150.591 78.3768 150.509 78.0941C150.427 77.8115 150.284 77.5503 150.091 77.329C149.897 77.1076 149.657 76.9316 149.389 76.8132L149.484 72.2123L146.71 71.4727L146.668 77.9718C146.499 78.4378 146.507 78.9496 146.69 79.4101C146.872 79.8707 147.217 80.248 147.659 80.4707C148.1 80.6933 148.608 80.7458 149.085 80.6181C149.562 80.4905 149.977 80.1916 150.249 79.778Z"
                    fill="#9F616A"
                />
                <path
                    d="M140.72 43.6645C140.72 43.6645 137.046 41.8217 133.576 43.0502C130.106 44.2787 128.27 45.712 128.27 45.712L130.515 57.5874L127.453 73.5578C127.453 73.5578 143.169 72.3293 144.598 73.5578C146.026 74.7863 146.026 72.1245 146.026 72.1245L144.802 56.9731L147.047 47.3499L140.72 43.6645Z"
                    fill="#7B67FB"
                />
                <path
                    d="M125.215 80.051C125.44 79.8622 125.621 79.6263 125.746 79.3597C125.87 79.0931 125.935 78.8024 125.935 78.508C125.936 78.2136 125.872 77.9227 125.748 77.6558C125.624 77.3888 125.443 77.1524 125.219 76.9631L126.597 72.574L124.143 71.083L122.283 77.3087C121.991 77.7086 121.855 78.202 121.901 78.6954C121.948 79.1889 122.173 79.6481 122.534 79.9862C122.896 80.3242 123.368 80.5175 123.862 80.5294C124.356 80.5413 124.837 80.3711 125.215 80.051Z"
                    fill="#9F616A"
                />
                <path
                    d="M129.699 45.7119H128.271C128.271 45.7119 126.025 47.1452 126.025 49.1926C126.025 51.2401 122.76 75.1957 122.76 75.1957L126.229 75.81L129.291 59.0206L131.536 54.5161L129.699 45.7119Z"
                    fill="#7B67FB"
                />
                <path
                    d="M143.17 47.3506H147.048C147.048 47.3506 148.272 48.5791 148.885 51.4456C149.497 54.312 150.109 65.5732 150.109 65.5732L149.701 75.8107H146.64L146.231 62.502L144.19 53.9026L143.17 47.3506Z"
                    fill="#7B67FB"
                />
                <path
                    d="M172.467 116.5H106.682C106.637 116.5 106.593 116.482 106.56 116.449C106.528 116.417 106.51 116.372 106.51 116.327C106.51 116.281 106.528 116.237 106.56 116.204C106.593 116.172 106.637 116.153 106.682 116.153H172.467C172.513 116.153 172.557 116.172 172.589 116.204C172.622 116.237 172.64 116.281 172.64 116.327C172.64 116.372 172.622 116.417 172.589 116.449C172.557 116.482 172.513 116.5 172.467 116.5Z"
                    fill="#CBCBCB"
                />
            </g>
            <defs>
                <clipPath id="clip0_7735_372142">
                    <rect
                        width="153"
                        height="113"
                        fill="white"
                        transform="translate(33.5 3.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
